<mat-toolbar matDialogTitle class="mat-accent m-0">
  <mat-toolbar-row fxLayout="row" fxLayoutAlign="start center">
    <h1 mat-dialog-title>הקלטת שם איש קשר</h1>
  </mat-toolbar-row>
</mat-toolbar>
<div mat-dialog-content *ngIf="formData" [formGroup]="formData">
  <div fxLayout="column" class="form-vertical" fxLayoutGap="15px">

    <div class="form-row" fxLayout="row" fxLayout.xs="column">
      <div class="input-group mb-3">
        <label>שם איש:</label>
        <input style="font-weight: bold;" type="text" class="form-control" [disabled]="true"
          [value]="data.contactName">
      </div>
    </div>

  <div class="form-row" fxLayout="column" fxLayout.xs="column">
       <label>קובץ שמע:</label>
      <div class="mat-caption text-warn">פורמט נדרש: WAV 8KHZ 16BIT PCM ULAW</div>

      <div fxLayout="row" fxLayoutAlign="start stretch">
        <button mat-stroked-button color="primary" (click)="fileInput.click()">
          <mat-icon class="mr-8">upload_file</mat-icon>
          בחר קובץ
        </button>
        <input #fileInput type="file" (change)="onFileSelected($event)" accept=".wav" style="display:none;">
        <span *ngIf="fileName" class="mat-body-1">{{fileName}}</span>
      </div>

      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <div class="mat-body-1">או הקלט:</div>
        <button mat-mini-fab color="warn" (click)="startRecording()" *ngIf="!isRecording" matTooltip="התחל הקלטה">
          <mat-icon>mic</mat-icon>
        </button>
        <button mat-mini-fab color="accent" (click)="stopRecording()" *ngIf="isRecording" matTooltip="עצור הקלטה">
          <mat-icon>stop</mat-icon>
        </button>
        <span *ngIf="isRecording" class="blink mat-body-2 text-warn">מקליט... {{recordingTime}}</span>
      </div>

      <div *ngIf="audioUrl" fxLayout="column" fxLayoutGap="5px" class="mt-8">
        <span class="mat-caption">תצוגה מקדימה:</span>
        <audio [src]="audioUrl" controls style="width: 100%; height: 40px;"></audio>
      </div>
    </div>

  </div>
  <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
    <button mat-button (click)="onNoClick()">ביטול</button>
    <button mat-button [mat-dialog-close]="formData" [disabled]="!formData.valid">שמור</button>
  </div>
</div>
